module.exports = __webpack_public_path__ + "img/right-arrow-short--black.3d94d8a2.svg";